import { render, staticRenderFns } from "./GWorkKindCheckbox.vue?vue&type=template&id=0f993723&"
import script from "./GWorkKindCheckbox.vue?vue&type=script&lang=ts&"
export * from "./GWorkKindCheckbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports